import React, { useEffect } from 'react';
import TopContent from '../TopContent/TopContent';
import Works from '../Works/Works';
import Blog from '../Blog/Blog';
import Contact from '../Contact/Contact';
import './Home.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import Techs from '../Techs/Techs';

const Home = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return(
        <div className="home">
            <Nav />
            <div className="dvl-container">
                <TopContent />
                <h1 id="techs" className="dvl-center">Ulubione technologie</h1>
                <Techs />
                <h1 id="work" className="dvl-center">Prace</h1>
                <Works />
                <h1 id="blog" className="dvl-center">Blog</h1>
                <Blog />
                <h1 id="contact" className="dvl-center">Kontakt</h1>
                <Contact />
            </div>
            <Footer />
        </div>
    );
}

export default Home;